import { defineStore } from 'pinia';

export const usePlanEntrainementStore = defineStore('PlanEntrainement', {
    state: () => ({
        id: null,
        id_module: null,
        actif: false,
        titre: "Plan d'entraînement personnalisé",
        prix: 0,
        description: "",
        ids_courses: "",
        ids_courses_codes_disponibles: [],
    }),
    actions: {
        set(data) {
            if (!data) return;
            this.id = data.id;
            this.id_module = data.id_module;
            this.actif = data.actif;
            this.titre = data.titre;
            this.prix = data.prix;
            this.description = data.description;
            this.ids_courses = data.ids_courses || "";
            this.ids_courses_codes_disponibles = data.ids_courses_codes_disponibles || [];
        }
    },
});
